import request from '../../request'
import { useQuery } from 'react-query'
import { QUERY_CURRENT_USER_INSTITUTIONS } from '../../queryKeys/currentUser'
import useCurrentUserIdSelector from '../../selectors/useCurrentUserIdSelector'
import { setLocalStorage } from '@derolfgroep/utils/lib/misc/localStorage'
import { GROUP_TYPE_CLASS } from '../../../constants'

export const useCurrentUserInstitutions = () => {
  const currentUserId = useCurrentUserIdSelector()

  return useQuery(QUERY_CURRENT_USER_INSTITUTIONS, () => request({ endpoint: '/users/me/institutions' }), {
    onSuccess: (data) => {
      data.forEach((institute) =>
        setLocalStorage(
          `zc#.${currentUserId}.${institute.id}.groups`,
          institute.children?.filter((group) => group.type === GROUP_TYPE_CLASS)?.length
        )
      )
    },
  })
}
